import React from "react";
import Reveal from "./Reveal";

const institutions = [
  { icon: "🏛️", name: "Banaras Hindu University" },
  { icon: "🛡️", name: "Amity University" },
  { icon: "🎓", name: "Anna University" },
  { icon: "🏛️", name: "Osmania University" },
  { icon: "⚙️", name: "VIT University" },
  { icon: "🌿", name: "Jamia Millia Islamia" },
  { icon: "📐", name: "IIT Delhi" },
  { icon: "🔬", name: "Pune University" },
  { icon: "🌐", name: "Manipal University" },
  { icon: "📚", name: "Delhi University" },
];

export default function Institutions() {
  // duplicate the list so the CSS marquee animation loops seamlessly
  const looped = [...institutions, ...institutions];

  return (
    <section className="section-alt">
      <div className="wrap">
        <Reveal className="section-head">
          <div className="eyebrow">Scholar Network</div>
          <h2>Scholars from leading institutions</h2>
          <p>
            Our mentorship has supported PhD and Master's scholars from
            universities across India and internationally.
          </p>
        </Reveal>

        <div className="inst-track">
          <div className="inst-row">
            {looped.map((inst, i) => (
              <div className="inst" key={`${inst.name}-${i}`}>
                <span className="ic">{inst.icon}</span> {inst.name}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
